// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Link from "../../html/Link.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function Table2$Header(Props) {
  let header = Props.header;
  return Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, item) {
                    const Key = String(i);
                    return JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                className: Cn.$plus(Cn.$plus(Cn.$plus(Cn.$plus("py-3 border-b sticky top-0 border-gray-main bg-gray-pale border-t lg:border-t-0 text-gray-medium", Cn.on("pl-4 lg:pl-6 border-l lg:border-l-0 rounded-tl-md lg:rounded-none", i === 0)), Cn.on("pr-4 lg:pr-6", i <= (Stdlib__List.length(header) - 1 | 0))), Cn.on("border-r lg:border-r-0 rounded-tr-md lg:rounded-none", i === (Stdlib__List.length(header) - 1 | 0))), item.style),
                                children: item.name
                              }, Key);
                  }), header));
}

const Header = {
  make: Table2$Header
};

function make(i) {
  return function (length) {
    return function (cell) {
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                  className: Cn.$plus(Cn.$plus(Cn.$plus(Cn.$plus("py-2.5 border-b border-gray-main flex cursor-pointer group-hover:bg-gray-100", Cn.on("pl-4 lg:pl-6 border-l lg:border-l-0", i === 0)), Cn.on("pr-4 lg:pr-6", i <= (length - 1 | 0))), Cn.on("border-r lg:border-r-0", i === (length - 1 | 0))), cell.style),
                  children: JsxRuntime.jsx("span", {
                        children: cell.body,
                        className: "inline-flex items-center"
                      })
                }, Key);
    };
  };
}

function Table2$Cell(Props) {
  return Curry._1(make(Props.i)(Props.length), Props.cell);
}

const Cell = {
  make: Table2$Cell
};

function make$1(cells) {
  return function (route) {
    return function (onClick) {
      const children = Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, cell) {
                  const Key = String(i);
                  return JsxRuntime.jsx(Table2$Cell, {
                              i: i,
                              length: Stdlib__List.length(cells),
                              cell: cell
                            }, Key);
                }), cells));
      if (route !== undefined) {
        return JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                    route: route,
                    className: "contents text-left group",
                    children: children
                  });
      } else if (onClick !== undefined) {
        return JsxRuntime.jsx("button", {
                    children: children,
                    className: "contents text-left group",
                    onClick: onClick
                  });
      } else {
        return JsxRuntime.jsx("div", {
                    children: children,
                    className: "contents text-left group"
                  });
      }
    };
  };
}

function Table2$Row(Props) {
  return Curry._1(make$1(Props.cells)(Props.route), Props.onClick);
}

const Row = {
  make: Table2$Row
};

function make$2(header) {
  return function (rows) {
    return function (styles) {
      return function (showHeaderOpt) {
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Table2$Header, {
                                        header: header
                                      }),
                                  Belt__Belt_List.toArray(rows)
                                ],
                                className: Cn.$plus("grid overflow-x-auto px-4 py-6 lg:p-0", styles)
                              }),
                          className: "grow"
                        }),
                    className: Cn.$plus("flex flex-col w-full", Cn.on("hidden", false))
                  });
      };
    };
  };
}

function Table2(Props) {
  return Curry._2(make$2(Props.header)(Props.rows), Props.styles, Props.showHeader);
}

const make$3 = Table2;

export {
  Header ,
  Cell ,
  Row ,
  make$3 as make,
}
/* Buhta_cabinet__Link Not a pure module */
